"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resetIdentity = exports.identify = void 0;
const constants_1 = require("../constants");
exports.identify = ({ session }) => {
    const id = session.userID;
    const props = {
        [constants_1.EventProperty.CHANNEL]: session.channel,
        [constants_1.EventProperty.USER_ID]: id,
        [constants_1.EventProperty.SESSION_ID]: session.sessionID
    };
    if (session.customer && session.customerCode) {
        const customerCodePropName = `${constants_1.EventProperty.CUSTOMER_CODE}[${session.customer}]`;
        props[customerCodePropName] = session.customerCode;
    }
    window.analytics.identify(id, props);
};
exports.resetIdentity = () => {
    window.analytics.reset();
};
